var _a, _b;
import { DatePickerRepeat, TimePickerRepeat } from '../Datetime/types';
import { i18n } from '@lingui/core';
export var DatePickerRepeatTrans = (_a = {},
    _a[DatePickerRepeat.EVERY_TODAY] = i18n._({ id: 'dataGrid.everyToday', message: 'Every today' }),
    _a[DatePickerRepeat.EVERY_YESTERDAY] = i18n._({ id: 'dataGrid.everyYesterday', message: 'Every yesterday' }),
    _a);
export var TimePickerRepeatTrans = (_b = {},
    _b[TimePickerRepeat.FROM] = i18n._({ id: 'dataGrid.timepicker.from', message: 'from' }),
    _b[TimePickerRepeat.TO] = i18n._({ id: 'dataGrid.timepicker.to', message: 'to' }),
    _b[TimePickerRepeat.AT] = i18n._({ id: 'dataGrid.timepicker.at', message: 'at' }),
    _b);
